import { Card, Radio, Skeleton, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import CustomHeader from "../common/Header";
import HTTP from "../../services/httpService";
import HotelList from "../common/HotelList";
import "./Hotel.css";

const { TabPane } = Tabs;

const deviceOptions = [
    { label: "Aavgo", value: "1" },
    { label: "Aavya", value: "2" },
    { label: "Lenovo", value: "3" },
];

function Category() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [tableData, setTableData] = useState([]);
    const [SelectedDeviceOptions, setSelectedDeviceOptions] = useState(0);
    const [showSkeleton, setShowSkeleton] = useState(true);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [currentPageLimit, setCurrentPageLimit] = useState(0);

    useEffect(() => {
        async function fetchData() {
            const { data: response, total } = await HTTP(
                "/dashboard/getKioskHotels",
                {
                    staff_id,
                    page: 0,
                    limit: 10,
                },
            );
            setCurrentPage(1);
            setCurrentPageLimit(10);
            setTotalRecords(total);
            setShowSkeleton(false);
            if (response.length > 0) {
                /* const response1 = response.map((e) => {
					e.address = `${e.street}, ${e.city}, ${e.state} , ${e.zipcode}`;
					return e;
				}); */
                setTableData(response);
            }
        }
        fetchData();
    }, []);

    async function changeView(key_url) {
        const [key, site] = key_url.split("-");
        setTableData([]);
        setShowSkeleton(true);
        setCurrentPage(1);
        setCurrentPageLimit(10);
        const formData = {
            staff_id,
            page: 0,
            limit: 10,
        };
        if (key === "GuestExperienceHotels") {
            formData.type = 1;
            setSelectedDeviceOptions("1");
        }
        if (key === "SiteWiseHotels") {
            formData.site = site;
        }
        const { data: response, total } = await HTTP(
            `/dashboard/get${key.trim()}`,
            formData,
        );
        setTotalRecords(total);
        setShowSkeleton(false);
        if (response.length > 0) {
            /* const response1 = response.map((e) => {
				e.address = `${e.street}, ${e.city}, ${e.state} , ${e.zipcode}`;
				return e;
			}); */
            setTableData(response);
        }
    }

    async function fatchGuestExperienceHotels(
        e,
        page = 0,
        limit = 10,
        sorting = undefined,
        sort_by = undefined,
        pageChanged = false,
    ) {
        setSelectedDeviceOptions(e.target.value);
        setCurrentPage(page + 1);
        setCurrentPageLimit(limit);
        if (!pageChanged) {
            setTableData([]);
            setTotalRecords(0);
            setShowSkeleton(true);
        }

        const formData = {
            staff_id,
            type: e.target.value,
            page,
            limit,
        };
        if (sort_by !== undefined && sorting !== undefined) {
            formData.sort_by = sort_by;
            formData.sorting = sorting;
        }
        const { data: response, total } = await HTTP(
            `/dashboard/getGuestExperienceHotels`,
            formData,
        );
        setTotalRecords(total);
        setShowSkeleton(false);
        if (response.length > 0) {
            /* const response1 = response.map((e) => {
				e.address = `${e.street}, ${e.city}, ${e.state} , ${e.zipcode}`;
				return e;
			}); */
            setTableData(response);
        }
    }

    async function handlePageChange(...rest) {
        const [params] = rest;
        const { page, limit, key, sorting, sort_by, site } = params;
        setCurrentPage(page + 1);
        setCurrentPageLimit(limit);
        const formData = {
            staff_id,
            page,
            limit,
        };
        if (sorting !== undefined && sort_by !== undefined) {
            formData.sorting = sorting;
            formData.sort_by = sort_by;
        }
        if (key === "GuestExperienceHotels") {
            // formData.type = 1;
            setSelectedDeviceOptions("1");
            const e = { target: { value: SelectedDeviceOptions } };
            return fatchGuestExperienceHotels(
                e,
                page,
                limit,
                sorting,
                sort_by,
                true,
            );
        }
        if (site) {
            formData.site = site;
        }
        const { data: response, total } = await HTTP(
            `/get${key.trim()}`,
            formData,
        );
        setTotalRecords(total);

        if (response.length > 0) {
            const response1 = response.map((e) => {
                e.address = `${e.street}, ${e.city}, ${e.state} , ${e.zipcode}`;
                return e;
            });
            setTableData(response1);
        }
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            <Card className="box-shadow margin-10">
                <Tabs
                    onChange={changeView}
                    destroyInactiveTabPane={true}
                    type="card"
                >
                    <TabPane tab="Kiosk Hotels" key="KioskHotels">
                        {!showSkeleton ? (
                            <HotelList
                                tableData={tableData}
                                id="KioskHotels"
                                noOfrecords={totalRecords}
                                handlePageChange={handlePageChange}
                                currentPage={currentPage}
                                currentPageLimit={currentPageLimit}
                            />
                        ) : (
                            <Skeleton
                                active
                                title={false}
                                paragraph={{ rows: 20, width: 40 }}
                            />
                        )}
                    </TabPane>
                    <TabPane tab="Panic Hotels" key="PanicHotels">
                        {!showSkeleton ? (
                            <HotelList
                                tableData={tableData}
                                id="PanicHotels"
                                noOfrecords={totalRecords}
                                handlePageChange={handlePageChange}
                                currentPage={currentPage}
                                currentPageLimit={currentPageLimit}
                            />
                        ) : (
                            <Skeleton
                                active
                                title={false}
                                paragraph={{ rows: 20, width: 40 }}
                            />
                        )}
                    </TabPane>
                    <TabPane tab="Operational Hotels" key="OperationalHotels">
                        {!showSkeleton ? (
                            <HotelList
                                tableData={tableData}
                                id="OperationalHotels"
                                noOfrecords={totalRecords}
                                handlePageChange={handlePageChange}
                                currentPage={currentPage}
                                currentPageLimit={currentPageLimit}
                            />
                        ) : (
                            <Skeleton
                                active
                                title={false}
                                paragraph={{ rows: 20, width: 40 }}
                            />
                        )}
                    </TabPane>
                    <TabPane
                        tab="Guest Experience Hotels"
                        key="GuestExperienceHotels"
                    >
                        <Radio.Group
                            className="guest-experience-radio"
                            options={deviceOptions}
                            onChange={fatchGuestExperienceHotels}
                            value={SelectedDeviceOptions}
                        />

                        {!showSkeleton ? (
                            <HotelList
                                tableData={tableData}
                                id="GuestExperienceHotels"
                                noOfrecords={totalRecords}
                                handlePageChange={handlePageChange}
                                currentPage={currentPage}
                                currentPageLimit={currentPageLimit}
                            />
                        ) : (
                            <Skeleton
                                active
                                title={false}
                                paragraph={{ rows: 20, width: 40 }}
                            />
                        )}
                    </TabPane>
                    <TabPane tab="Site A Hotels" key="SiteWiseHotels-a">
                        {!showSkeleton ? (
                            <HotelList
                                tableData={tableData}
                                id="SiteWiseHotels"
                                noOfrecords={totalRecords}
                                handlePageChange={handlePageChange}
                                currentPage={currentPage}
                                currentPageLimit={currentPageLimit}
                                site="a"
                            />
                        ) : (
                            <Skeleton
                                active
                                title={false}
                                paragraph={{ rows: 20, width: 40 }}
                            />
                        )}
                    </TabPane>
                    <TabPane tab="Site B Hotels" key="SiteWiseHotels-b">
                        {!showSkeleton ? (
                            <HotelList
                                tableData={tableData}
                                id="SiteWiseHotels"
                                noOfrecords={totalRecords}
                                handlePageChange={handlePageChange}
                                currentPage={currentPage}
                                currentPageLimit={currentPageLimit}
                                site="b"
                            />
                        ) : (
                            <Skeleton
                                active
                                title={false}
                                paragraph={{ rows: 20, width: 40 }}
                            />
                        )}
                    </TabPane>
                </Tabs>
            </Card>
        </Card>
    );
}

export { Category };
